import btoa from 'btoa'
import atob from 'atob'

export function encrypt(token: string): string {
	return btoa(btoa(token)).replace(/=/g, '')
}

export function decrypt(token: string): string {
	return atob(atob(token))
}
